import css from 'styled-jsx/css';

// styled-jsx is component-scoped, so .label and .row are re-declared here
// rather than inherited from PurposeStatusModal.styles.
const style = css`
  .override-row {
    border: 1px solid #e7e7e7;
    border-radius: 4px;
    padding: 8px 12px 4px;
    margin-bottom: 12px;
  }
  .override-row-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  .override-row-title {
    font-size: 13px;
    font-weight: 600;
    color: #666668;
  }
  .override-row-remove {
    width: 12px;
    height: 12px;
    cursor: pointer;
    opacity: 0.5;
  }
  .override-row-remove:hover {
    opacity: 1;
  }
  .override-field {
    margin-bottom: 8px;
  }
  /* Status + block reasons share a line. flex-start keeps both selects level
     even if one label wraps. */
  .override-duo {
    display: flex;
    align-items: flex-start;
  }
  .override-duo-col {
    width: 50%;
    min-width: 0;
  }
  .override-duo-col + .override-duo-col {
    margin-left: 12px;
  }
  .label {
    font-size: 14px;
    margin-bottom: 4px;
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;

export default style;
